module.exports = __webpack_public_path__ + "static/logo_white-9d5c6de7647370fe12401a5754f20042.svg";